import React from 'react';
import classnames from 'classnames';
import Plus from '@wix/da-ds/pkg/Icons/16x16/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Check from '@wix/da-ds/pkg/Icons/16x16/Check';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { useWatchButton } from '../../WatchButton/useWatchButton';
import s from './AuthorWatchButton.scss';
export const AuthorWatchButton = ({ author, className, children, onWatch, iconClassName, isWatchingBack, ghostButton, watchingClassname, isSummary, disabled, onToggleWatchSuccess })=>{
    const { onClick, text, isWatching, biData } = useWatchButton(author, author === null || author === void 0 ? void 0 : author.isWatching, isWatchingBack, disabled, onToggleWatchSuccess);
    const buttonContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Plus, {
        disableDefaultColors: true,
        className: classnames(s['plus-icon'], iconClassName),
        size: IconSize.SMALLER
    }), /*#__PURE__*/ React.createElement(Close, {
        disableDefaultColors: true,
        className: classnames(s['close-icon'], iconClassName),
        size: IconSize.SMALLER
    }), isWatching && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Check, {
        disableDefaultColors: true,
        className: classnames(s['check-icon'], iconClassName),
        size: IconSize.SMALLER
    })), children || text);
    const onClickHandler = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClick();
        onWatch && onWatch();
    };
    if (ghostButton) {
        return /*#__PURE__*/ React.createElement(GhostButton, {
            size: isSummary ? 'medium' : 'small',
            variant: 'main',
            biData: biData,
            className: classnames(s['root-ghost'], isWatching && s['watching'], isWatching && watchingClassname, className),
            onClick: onClickHandler,
            disabled: disabled || isSummary && isWatching
        }, buttonContent);
    }
    return /*#__PURE__*/ React.createElement(TextButton, {
        variant: "approval-green",
        size: "small",
        biData: biData,
        className: classnames(s['root'], isWatching && s['watching'], isWatching && watchingClassname, className),
        onClick: onClickHandler,
        disabled: disabled
    }, buttonContent);
};
AuthorWatchButton.displayName = 'AuthorWatchButton';
export default AuthorWatchButton;
